/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { TilvalgDto as OkEgisServiceModelsDtoTilvalgDto } from '../models/OK/Egis/Service/Models/DTO/tilvalg-dto';
import { TilvalgGroupDto as OkEgisServiceModelsDtoTilvalgGroupDto } from '../models/OK/Egis/Service/Models/DTO/tilvalg-group-dto';
import { CreateTilvalgRequest as OkEgisServiceModelsRequestCreateTilvalgRequest } from '../models/OK/Egis/Service/Models/Request/create-tilvalg-request';
import { UpdateTilvalgOnServiceaftaleRequest as OkEgisServiceModelsRequestUpdateTilvalgOnServiceaftaleRequest } from '../models/OK/Egis/Service/Models/Request/update-tilvalg-on-serviceaftale-request';
import { UpdateTilvalgRequest as OkEgisServiceModelsRequestUpdateTilvalgRequest } from '../models/OK/Egis/Service/Models/Request/update-tilvalg-request';

@Injectable({
  providedIn: 'root',
})
export class TilvalgService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getTilvalgGroups
   */
  static readonly GetTilvalgGroupsPath = '/api/v1/Tilvalg';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTilvalgGroups()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTilvalgGroups$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoTilvalgGroupDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TilvalgService.GetTilvalgGroupsPath, 'get');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoTilvalgGroupDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTilvalgGroups$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTilvalgGroups(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoTilvalgGroupDto>> {

    return this.getTilvalgGroups$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoTilvalgGroupDto>>) => r.body as Array<OkEgisServiceModelsDtoTilvalgGroupDto>)
    );
  }

  /**
   * Path part for operation updateTilvalgOnServiceaftale
   */
  static readonly UpdateTilvalgOnServiceaftalePath = '/api/v1/Tilvalg';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTilvalgOnServiceaftale()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTilvalgOnServiceaftale$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateTilvalgOnServiceaftaleRequest
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TilvalgService.UpdateTilvalgOnServiceaftalePath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTilvalgOnServiceaftale$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTilvalgOnServiceaftale(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateTilvalgOnServiceaftaleRequest
  }): Observable<void> {

    return this.updateTilvalgOnServiceaftale$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation getTilvalgGroupsForServiceabonnement
   */
  static readonly GetTilvalgGroupsForServiceabonnementPath = '/api/v1/Tilvalg/GetTilvalgGroupsForServiceabonnement';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getTilvalgGroupsForServiceabonnement()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTilvalgGroupsForServiceabonnement$Response(params: {
    serviceAbonnementId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<Array<OkEgisServiceModelsDtoTilvalgGroupDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TilvalgService.GetTilvalgGroupsForServiceabonnementPath, 'get');
    if (params) {
      rb.query('serviceAbonnementId', params.serviceAbonnementId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<OkEgisServiceModelsDtoTilvalgGroupDto>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getTilvalgGroupsForServiceabonnement$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getTilvalgGroupsForServiceabonnement(params: {
    serviceAbonnementId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<Array<OkEgisServiceModelsDtoTilvalgGroupDto>> {

    return this.getTilvalgGroupsForServiceabonnement$Response(params).pipe(
      map((r: StrictHttpResponse<Array<OkEgisServiceModelsDtoTilvalgGroupDto>>) => r.body as Array<OkEgisServiceModelsDtoTilvalgGroupDto>)
    );
  }

  /**
   * Path part for operation createTilvalg
   */
  static readonly CreateTilvalgPath = '/api/v1/Tilvalg/CreateTilvalg';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createTilvalg()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTilvalg$Response(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestCreateTilvalgRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoTilvalgDto>> {

    const rb = new RequestBuilder(this.rootUrl, TilvalgService.CreateTilvalgPath, 'post');
    if (params) {
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoTilvalgDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createTilvalg$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createTilvalg(params: {

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestCreateTilvalgRequest
  }): Observable<OkEgisServiceModelsDtoTilvalgDto> {

    return this.createTilvalg$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoTilvalgDto>) => r.body as OkEgisServiceModelsDtoTilvalgDto)
    );
  }

  /**
   * Path part for operation updateTilvalg
   */
  static readonly UpdateTilvalgPath = '/api/v1/Tilvalg/UpdateTilvalg';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateTilvalg()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTilvalg$Response(params: {
    tilvalgId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateTilvalgRequest
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoTilvalgDto>> {

    const rb = new RequestBuilder(this.rootUrl, TilvalgService.UpdateTilvalgPath, 'put');
    if (params) {
      rb.query('tilvalgId', params.tilvalgId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoTilvalgDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateTilvalg$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateTilvalg(params: {
    tilvalgId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
    body?: OkEgisServiceModelsRequestUpdateTilvalgRequest
  }): Observable<OkEgisServiceModelsDtoTilvalgDto> {

    return this.updateTilvalg$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoTilvalgDto>) => r.body as OkEgisServiceModelsDtoTilvalgDto)
    );
  }

  /**
   * Path part for operation deleteTilvalg
   */
  static readonly DeleteTilvalgPath = '/api/v1/Tilvalg/DeleteTilvalg';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteTilvalg()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTilvalg$Response(params: {
    tilvalgId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<StrictHttpResponse<OkEgisServiceModelsDtoTilvalgDto>> {

    const rb = new RequestBuilder(this.rootUrl, TilvalgService.DeleteTilvalgPath, 'delete');
    if (params) {
      rb.query('tilvalgId', params.tilvalgId, {});
      rb.header('correlationId', params.correlationId, {});
      rb.header('caller', params.caller, {});
      rb.header('userId', params.userId, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OkEgisServiceModelsDtoTilvalgDto>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteTilvalg$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteTilvalg(params: {
    tilvalgId?: number;

    /**
     * Correlation Id for the request
     */
    correlationId?: string;

    /**
     * The name of the program performing the request
     */
    caller: string;

    /**
     * User Id
     */
    userId?: string;
  }): Observable<OkEgisServiceModelsDtoTilvalgDto> {

    return this.deleteTilvalg$Response(params).pipe(
      map((r: StrictHttpResponse<OkEgisServiceModelsDtoTilvalgDto>) => r.body as OkEgisServiceModelsDtoTilvalgDto)
    );
  }

}
